const { ofetch } = require("ofetch");

$(function() {
    const mediaQuery = window.matchMedia('(min-width: 992px)');
    const carousel1CParams = {
        imagesLoaded:true,
        percentPosition:false,
        prevNextButtons:false,
        pageDots:false,
        cellAlign:'left'
    }
    let $carousel1CDynamic = $('.component-carousel-1c__carousel--dynamic');
    const fetchData = function() {
        $carousel1CDynamic.each(async function(index, element) {
            var $element = $(element);

            const action = $element.data('carousel1c-fetch');
            const response = await ofetch(action, {
                method: "GET",
            });
            $element.height($element.outerHeight());
            //$element.html(response);
            //handleScreenChange(mediaQuery);
            $element.html(response).flickity(carousel1CParams);
            /*window.setTimeout(function() {
                $element.height('auto');
            },1000)*/
        })
    }

    fetchData();

    function handleScreenChange(e) {
        // If the media query matches (screen is wider than 768px)
        if (e.matches) {
            // Initialize Flickity if it's not already initialized
            if (!$carousel1CDynamic.hasClass('flickity-enabled')) {
                $carousel1CDynamic.flickity(carousel1CParams);
            }
        } else {
            // If the media query doesn't match (screen is narrower than 768px)
            // and Flickity is initialized, destroy it.
            if ($carousel1CDynamic.hasClass('flickity-enabled')) {
                $carousel1CDynamic.flickity('destroy');
            }
        }
    }

    //handleScreenChange(mediaQuery);
    mediaQuery.addEventListener('change', handleScreenChange);
});
